import SuccessStory from './successStory'

// No wrapper: the banner is a direct child of the tab's gap column, like the
// cards on either side of it.
export default function Banners() {
    return <SuccessStory />
}
